import Vuex from 'vuex';
import Vue from 'vue';

Vue.use(Vuex);

// Create store
export default new Vuex.Store({});
